import { useEffect, useState } from 'react';
import api from '../../services/ApiService';
import type { PassportVisual } from '@bilt/domain/passportVisual';
const kindVisuals = new Map<string, Promise<PassportVisual | undefined>>();
/** One request per kind/session, never one per listing item. Failure preserves the built-in face. */
export function usePassportKindVisual(kind: string | null) {
  const generation = api.sessionGeneration;
  const [value, setValue] = useState<{ key: string; visual?: PassportVisual }>();
  const key = `${generation}:${kind}`;
  useEffect(() => {
    let active = true;
    if (!kind) return;
    if (!kindVisuals.has(key)) {
      if (kindVisuals.size > 30) kindVisuals.clear();
      kindVisuals.set(
        key,
        typeof api.makeRequest === 'function'
          ? api
              .makeRequest<{ visual: PassportVisual | null }>(
                `/passport_card_style.php?kind=${encodeURIComponent(kind)}`
              )
              .then((result) =>
                result.success && result.data?.visual ? result.data.visual : undefined
              )
              .catch(() => undefined)
          : Promise.resolve(undefined)
      );
    }
    void kindVisuals.get(key)!.then((visual) => {
      if (active && generation === api.sessionGeneration) setValue({ key, visual });
    });
    return () => {
      active = false;
    };
  }, [generation, key, kind]);
  return value?.key === key ? value.visual : undefined;
}
